import { ILanguageNode } from '@packlink/translation-provider';
import { SET_AVAILABLE_LANGUAGES, SET_LOCALE, LanguageAction } from '@store/actions';

export interface ILanguageState {
    availableLanguages: ILanguageNode[];
    locale: string;
}

export const initialState = {
    availableLanguages: [],
    locale: 'es-ES',
};

export const reducer = (state: ILanguageState = initialState, action: LanguageAction): ILanguageState => {
    const { type, payload } = action;

    switch (type) {
        case SET_AVAILABLE_LANGUAGES: {
            const languages = payload as ILanguageNode[];
            return { ...state, availableLanguages: languages };
        }
        case SET_LOCALE: {
            const locale = payload as string;
            return { ...state, locale };
        }
        default:
            return state;
    }
};
